const refillNamingAreaExceptions = [
  "OW",
  "CL",
  "SSFA",
  "AA",
  "AS",
  "ST",
  "WH",
  "OT",
];
export default refillNamingAreaExceptions;
